"use strict";

import "@/bootstrap.js";

import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";

import { INERTIA_PROGRESS, installCommon } from "@/lib/inertia-app.js";

import { registerScrollSpy } from "vue3-scroll-spy";
import VueScrollTo from "vue-scrollto";
import { Vue3Mq } from "vue3-mq";
import PrimeVue from "primevue/config";
import { NYLON_PRIMEVUE_OPTIONS } from "@/nylon/primevue-preset.js";

createInertiaApp({
  progress: INERTIA_PROGRESS,

  // Suffixes every <Head :title="..."> with the site name. Matches the format in
  // resources/views/_inertia-storefront.blade.php for first-paint parity.
  title: (title) => (title ? `${title} | Cotton Bureau` : "Cotton Bureau"),

  resolve: (name) => resolvePageComponent(`./${name}.vue`, import.meta.glob(["./storefront/**/*.vue", "./account/**/*.vue"])),

  setup({ el, App, props, plugin }) {
    const app = createApp({ render: () => h(App, props) });

    app.use(plugin);
    installCommon(app);
    app.use(VueScrollTo);
    app.use(Vue3Mq, {
      breakpoints: {
        fullscreen: 0,
        desktop: 768,
      },
    });
    app.use(PrimeVue, NYLON_PRIMEVUE_OPTIONS);
    registerScrollSpy(app);

    app.mount(el);
  },
});
